import { render, staticRenderFns } from "./inviteEmployee.vue?vue&type=template&id=b977d13a&scoped=true&"
import script from "./inviteEmployee.vue?vue&type=script&lang=js&"
export * from "./inviteEmployee.vue?vue&type=script&lang=js&"
import style0 from "./inviteEmployee.vue?vue&type=style&index=0&id=b977d13a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b977d13a",
  null
  
)

export default component.exports